import { render, staticRenderFns } from "./TradersCurrenciesAndPaymentMethods.vue?vue&type=template&id=3b3e626c&"
import script from "./TradersCurrenciesAndPaymentMethods.vue?vue&type=script&lang=js&"
export * from "./TradersCurrenciesAndPaymentMethods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports